import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import PropTypes from "prop-types";
import { P2Alert } from "./../../P2Alert";
import { P2TextLabel } from "./../../P2Text";

const P2TextArea = React.forwardRef(({ ...props }, ref) => {
  const [holdingText, setHoldingText] = useState(
    props.value ? props.value : ""
  );
  const textAreaRef = useRef(null);

  const [isDirty, setDirty] = useState(false);
  const [isFocus, setFocus] = useState(false);
  const [isBlur, setBlur] = useState(true);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    let timeoutID;
    timeoutID = window.setTimeout(() => {
      if (isDirty && !isFocus && isBlur) {
        setShowError(true);
      } else {
        setShowError(false);
      }
    }, 200);
    return () => {
      clearTimeout(timeoutID);
    };
  }, [isDirty, isFocus, isBlur]);

  useImperativeHandle(
    ref,
    () => {
      return {
        clearHoldingText() {
          setHoldingText("");
        },
      };
    },
    [isDirty, holdingText]
  );

  return (
    <div className="polymer-textarea-form">
      {props.label && (
        <P2TextLabel
          bold={props.labelFontWeight}
          marginBottom="8px"
          label={props.label}
          required={props.required}
          hasTooltip={props.hasTooltip}
          tooltipContent={props.tooltipContent}
        />
      )}
      <div className="polymer-textarea-form__textarea-container">
        <textarea
          style={{
            maxWidth: props.width,
            padding: props.textAreaPadding,
            borderColor: isBlur && props?.value?.length > 0 ? "#575757" : "",
            backgroundColor:
              isBlur && props?.value?.length > 0 ? "#F7F7F7" : "",
          }}
          ref={textAreaRef}
          placeholder={props.placeholder}
          rows={props.rows}
          maxLength={props.maxLength}
          minLength={props.minLength}
          disabled={props.disabled}
          aria-disabled={props.disabled}
          value={props.value}
          onChange={(e) => {
            const { value } = e.target;
            if (value !== "") {
              setDirty(true);
            }

            if (props.onChange) {
              props.onChange(value);
            }
          }}
          onFocus={() => {
            setFocus(true);
            setBlur(false);
          }}
          onBlur={(e) => {
            setBlur(true);
            setFocus(false);
          }}
        ></textarea>
      </div>
      {
        props.isError && showError && (
          <div style={{ marginTop: 24 }}>
            <P2Alert variant={"danger"} text={props.errorMsg} />
          </div>
        )
        // <p className='m-0' style={{color:'red'}}>{props.errorMsg}</p>
      }
    </div>
  );
});

export default P2TextArea;

P2TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  rows: PropTypes.number,
  hasTooltip: PropTypes.bool,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  errorMsg: PropTypes.string,
  isError: PropTypes.bool,
  onBlur: PropTypes.func,
  width: PropTypes.string,
  labelFontWeight: PropTypes.number | PropTypes.string,
  textAreaPadding: PropTypes.string,
};

P2TextArea.defaultProps = {
  variant: "default",
  required: false,
  disabled: false,
  hasTooltip: false,
  tooltipContent:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  isError: false,
};
